// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"TimelineComments\"] {\n  width: 100%;\n}\n  [name=\"TimelineComments\"].focus [name=\"TimelineComment\"]:not(.focus) {\n    opacity: 0.5;\n    pointer-events: none;\n    cursor: default;\n  }", ""]);
// Exports
module.exports = exports;
